export default __webpack_public_path__ + "static/header-85270b1c18607d4eb76dcba9edb5c072.png";